/**
 * CE QU'UNE PIÈCE JOINTE A LE DROIT D'ÊTRE — module PUR, les deux côtés.
 *
 * Il existe parce que l'écran et le serveur doivent dire la MÊME chose : un
 * écran plus permissif laisse l'utilisateur attendre pour rien, un écran plus
 * strict refuse ce que le serveur accepterait. La règle vit donc à un seul
 * endroit, et `server/lib/conges-validators.ts` comme `src/lib/piece-jointe.ts`
 * l'appellent. Aucune dépendance : le frontend l'importait d'abord depuis les
 * schémas Zod, et emportait zod tout entier dans le navigateur pour un entier.
 *
 * **AUCUN PLAFOND DE TAILLE** (règle posée par Valérie le 07/10/2026) : les
 * 10 Mo ne concernent QUE les factures fournisseurs (`UploadModal`,
 * `routes/invoices.ts`), parce qu'une facture est un PDF que le fournisseur
 * produit. Partout ailleurs — justificatifs de congés, arrêts de travail,
 * attestations, notes de frais — la pièce est un document SUBI : scanné par la
 * CPAM, photographié dans un parking, remis par un tiers. Celui qui le dépose
 * ne peut pas le refaire plus léger, et le refuser serait une panne pour lui,
 * pas une protection.
 *
 * Ce qui reste refusé, c'est seulement ce qui s'EXÉCUTE, et cela ne dépend ni
 * du module ni de qui dépose.
 */

/**
 * Les types qui s'EXÉCUTENT quand la pièce est rouverte.
 *
 * Une pièce est resservie avec son propre type dans un onglet
 * (`URL.createObjectURL` puis `window.open`) : du HTML ou un SVG y porterait du
 * script dans l'origine de l'application. Ce refus vaut pour TOUTES les pièces,
 * celles de la RH comprises (validé par Valérie le 07/10/2026) — ce n'est pas un
 * plafond, c'est une protection, et personne ne dépose un arrêt de travail en SVG.
 *
 * Ce n'est PAS une liste blanche, volontairement : un mobile étiquette parfois
 * `application/octet-stream` un PDF parfaitement valide, et refuser un arrêt de
 * travail lisible serait absurde.
 */
const TYPES_EXECUTABLES = ['text/html', 'image/svg+xml', 'application/xhtml+xml'];

export function estTypeExecutable(mime: string | null | undefined): boolean {
  if (!mime) return false;
  return TYPES_EXECUTABLES.includes(mime.split(';')[0]!.trim().toLowerCase());
}

export const MESSAGE_TYPE_REFUSE =
  'Ce type de fichier n’est pas accepté comme pièce jointe. Déposez une photo ou un PDF.';

/** Pourquoi cette pièce est refusée, ou `null` si elle est acceptable. */
export function refusDePiece(piece: { mime?: string | null }): string | null {
  return estTypeExecutable(piece.mime) ? MESSAGE_TYPE_REFUSE : null;
}
